module.exports = __webpack_public_path__ + "img/se_region_logo.0d15f98a.png";